import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '一、版权所有',
    content: `本网站（xunyutech.cn）及寻御科技平台（以下统称"本平台"）上所有内容的版权归寻御科技（上海）有限公司（以下简称"本公司"）所有，受中华人民共和国《著作权法》及相关国际公约的保护。

受版权保护的内容包括但不限于：
• 本平台的软件代码、程序、数据库及其结构；
• 本平台的界面设计、图标、图形、视觉元素；
• 本平台发布的所有文字、图片、图表、视频内容；
• 本公司的产品介绍、方案文档、行业报告；
• 本平台的算法模型、业务逻辑及技术实现方案；
• 本公司的品牌标识、商标、标语及相关设计。`,
  },
  {
    title: '二、商标声明',
    content: `"寻御科技"、"寻御"及相关图形标识均为寻御科技（上海）有限公司的注册商标或商业标识，受中华人民共和国《商标法》保护。

未经本公司书面授权，任何单位或个人不得：
• 将上述商标用于任何商业目的；
• 在宣传材料、产品包装或网站上使用上述商标；
• 以任何方式注册、使用与上述商标相同或近似的标识；
• 以任何方式暗示与本公司存在合作、关联或认可关系。`,
  },
  {
    title: '三、授权使用范围',
    content: `在遵守本声明的前提下，您可以：

• **个人浏览**：出于个人了解目的，在线浏览本平台内容；
• **合理引用**：在学术研究、新闻报道中合理引用本平台公开发布的内容，但须注明来源"寻御科技（xunyutech.cn）"；
• **分享链接**：通过社交媒体等渠道分享本平台页面链接（非内容本身）。

**禁止的行为**：
• 未经授权复制、下载、存储、再发布本平台内容；
• 对本平台内容进行修改、改编、翻译或创作衍生作品；
• 将本平台内容用于商业目的；
• 以爬虫、采集器等自动化方式批量获取本平台内容；
• 以任何方式损害本公司知识产权。`,
  },
  {
    title: '四、第三方内容',
    content: `本平台可能包含来自第三方的内容或链接至第三方网站。对于此类内容：

• 第三方内容的版权归其各自权利人所有，我们对其内容不承担责任；
• 我们不对链接网站的内容、隐私实践或安全性作任何担保；
• 访问第三方网站须遵守其各自的使用条款和版权声明；
• 若您发现本平台包含侵权内容，请立即告知我们，我们将及时处理。`,
  },
  {
    title: '五、用户原创内容',
    content: `您在使用本平台过程中上传、发布的内容（如评论、反馈、建议等）：

• 您保证对上述内容拥有合法权利，且不侵犯任何第三方权利；
• 您授予本公司在全球范围内免费、非独占的许可，以使用、展示和改进上述内容用于服务优化；
• 您对上述内容的真实性、合法性负责；
• 本公司有权删除违反法律法规或本条款的内容。`,
  },
  {
    title: '六、侵权处理',
    content: `若您认为本平台侵犯了您的版权或其他知识产权，请向我们发送书面通知，内容包括：

• 权利人的姓名/名称及联系方式；
• 被侵权内容的具体描述及其在本平台的位置；
• 您对所述内容拥有权利的证明材料；
• 您的声明，证明上述信息的准确性。

我们将在收到有效通知后 5 个工作日内进行核查处理。

**联系方式**：
• 邮箱：info@xunyutech.cn
• 电话：18916035855
• 地址：上海市虹口区水电路1388号`,
  },
  {
    title: '七、法律适用',
    content: `本版权声明受中华人民共和国法律管辖。若本声明任何部分与适用法律相抵触，以法律规定为准，其余部分继续有效。

任何因本版权声明引起的争议，应首先通过友好协商解决；协商不成的，可提交上海市虹口区有管辖权的人民法院诉讼解决。

本公司保留随时修改本版权声明的权利，修改后的声明自发布之日起生效。`,
  },
];

export default function CopyrightPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-firmai-dark">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-12 bg-firmai-darker overflow-hidden">
          <div className="absolute bottom-1/3 right-1/3 w-72 h-72 bg-firmai-green/6 rounded-full blur-3xl pointer-events-none" />
          <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
            <div className="max-w-3xl mx-auto">
              <nav className="flex items-center gap-2 text-xs text-firmai-muted mb-6">
                <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="hover:text-firmai-green transition-colors cursor-pointer">首页</a>
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-s-line" /></span>
                <span className="text-firmai-text">版权声明</span>
              </nav>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-firmai-green/10 border border-firmai-green/25 text-firmai-green text-xs font-semibold mb-4">
                <span className="w-3 h-3 flex items-center justify-center"><i className="ri-copyright-line" /></span>
                法律文件
              </span>
              <h1 className="font-display font-bold text-3xl md:text-4xl text-white mb-4">版权声明</h1>
              <p className="text-firmai-text text-sm leading-relaxed">
                最后更新日期：2026年1月1日 &nbsp;·&nbsp; 生效日期：2026年1月1日
              </p>
              <p className="text-firmai-muted text-sm mt-3 leading-relaxed max-w-2xl">
                本声明适用于寻御科技（上海）有限公司官方网站及旗下所有产品平台。未经明确授权，禁止对本平台任何内容进行复制、转载或商业使用。
              </p>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-14 bg-firmai-dark">
          <div className="w-full px-4 md:px-8 lg:px-12">
            <div className="max-w-3xl mx-auto">
              <div className="space-y-10">
                {sections.map((sec) => (
                  <div key={sec.title} className="bg-firmai-card border border-firmai-border rounded-xl p-6 md:p-8">
                    <h2 className="text-white font-bold text-base md:text-lg mb-4 flex items-center gap-2">
                      <span className="w-1 h-5 bg-firmai-green rounded-full inline-block shrink-0" />
                      {sec.title}
                    </h2>
                    <div className="text-firmai-text text-sm leading-relaxed">
                      {sec.content.split('\n').map((line, i) => {
                        if (line.startsWith('• **') && line.includes('**')) {
                          const match = line.match(/^• \*\*(.+?)\*\*：?(.*)$/);
                          if (match) {
                            return (
                              <p key={i} className="mb-2 pl-3">
                                <span className="text-firmai-green font-semibold">{match[1]}</span>
                                {match[2] ? <span>：{match[2]}</span> : null}
                              </p>
                            );
                          }
                        }
                        if (line.startsWith('• ')) {
                          return <p key={i} className="mb-2 pl-3 flex items-start gap-2"><span className="text-firmai-green mt-1.5 shrink-0">·</span>{line.replace('• ', '')}</p>;
                        }
                        if (line.startsWith('**') && line.endsWith('**')) {
                          return <p key={i} className="mb-2 text-white font-semibold">{line.replace(/\*\*/g, '')}</p>;
                        }
                        if (line === '') return <div key={i} className="h-2" />;
                        return <p key={i} className="mb-2">{line}</p>;
                      })}
                    </div>
                  </div>
                ))}
              </div>

              {/* Bottom nav */}
              <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-firmai-border">
                <div className="flex items-center gap-4 text-sm">
                  <a href="/privacy" onClick={(e) => { e.preventDefault(); navigate('/privacy'); }} className="text-firmai-muted hover:text-firmai-green transition-colors cursor-pointer">隐私政策</a>
                  <span className="text-firmai-border">|</span>
                  <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms'); }} className="text-firmai-muted hover:text-firmai-green transition-colors cursor-pointer">服务条款</a>
                </div>
                <a
                  href="/contact"
                  onClick={(e) => { e.preventDefault(); navigate('/contact'); }}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-firmai-green text-firmai-dark font-semibold rounded-md hover:bg-firmai-green/90 transition-all duration-200 whitespace-nowrap text-sm cursor-pointer"
                >
                  联系我们
                  <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}